import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createBlock as _createBlock, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-a571668c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "taks-parent-view__taskid" }
const _hoisted_2 = { class: "taks-parent-view__parent" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "taks-parent-view__parent-text" }, "Родительская задача", -1))
const _hoisted_4 = { class: "taks-parent-view__name" }
const _hoisted_5 = {
  key: 0,
  class: "taks-parent-view__delete-button"
}
const _hoisted_6 = { class: "taks-parent-view__confirm-popover" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "taks-parent-view__confirm-popover-message" }, " Открепить родительскую задачу? ", -1))
const _hoisted_8 = { class: "taks-parent-view__confirm-popover-buttons" }
const _hoisted_9 = { class: "taks-parent-view__menu-item" }
const _hoisted_10 = { class: "taks-parent-view__menu-item" }
const _hoisted_11 = { class: "taks-parent-view__menu-item" }
const _hoisted_12 = { class: "taks-parent-view__menu-item" }

import { computed, onMounted, PropType, ref } from 'vue';
import {
  TirPmButton,
  TirPmButtonSizeEnum,
  TirPmButtonVariantEnum,
  TirPmPopover,
  TirPmTooltipElementPlacementEnum,
  TirPmTooltipElement,
  TirPmContextMenu,
  TirPmContextMenuMouseButtonEnum,
  TirPmContextMenuButton,
  TirPmNotificationEventBus,
  TirPmNotificationModel,
  TirPmRouterLink,
} from 'tir-components';
import { RouteLocationRaw, RouterLink, useRouter } from 'vue-router';
import {
  ConnectIcon,
  TrashIcon,
  CurtainIcon,
  ArrowsPointingOutIcon,
  MapIcon,
  ShareIcon,
} from 'tir-style-system/icons/outline';
import { TaskParentModel } from '../../models';
import { TaskDrawer } from '../task-drawer';
import { TaskDrawerSettingsModel } from '../task-drawer';
import { copyToClipboard } from '../../utils';

/**Роутер */

export default /*#__PURE__*/_defineComponent({
  __name: 'taks-parent-view',
  props: {
  /**Родительская задача */
  parentTask: {
    type: Object as PropType<TaskParentModel>,
    required: true,
  },
  /**Загрузка при откреплении */
  isLoadingUnattach: {
    type: Boolean,
    default: false,
  },
  /**В шторке */
  inDrawer: {
    type: Boolean,
    default: false,
  },
  /**Показывать кнопку удаления */
  showDeleteButton: {
    type: Boolean,
    default: true,
  },
},
  emits: ["unattach"],
  setup(__props, { emit }) {

const props = __props;

const router = useRouter();





/**Ссылка на компонент контекстного меню */
const $contextMenu = ref<InstanceType<typeof TirPmContextMenu>>();
/**Ссылка на компонент шторки задачи */
const $taskDrawer = ref<InstanceType<typeof TaskDrawer>>();
/**Ссылка на компонент поповера подтверждения при откреплении задачи */
const $confirmUnattachPopover = ref<InstanceType<typeof TirPmPopover>>();

/**Вычисление маршрута до задачи */
const computedRoute = computed(() => {
  return router.resolve(getTaskRoute())?.href;
});

/**Получить роут на задачу */
const getTaskRoute = (): RouteLocationRaw => {
  return {
    name: 'task-detail',
    params: {
      projectId: props.parentTask.ProjectId,
      namespaceId: props.parentTask.NamespaceId,
      queueId: props.parentTask.QueueId,
      taskId: props.parentTask.Id,
    },
  };
};

/**Открыть задачу в шторке */
const openDrawer = () => {
  $contextMenu.value?.close();
  $taskDrawer.value?.open(
    new TaskDrawerSettingsModel({
      Mode: 'edit',
      TaskId: props.parentTask.Id,
    }),
  );
};
/**Открыть карту проекта */
const openSchema = computed(() => {
  return router.resolve({
    name: 'project-map',
    params: {
      taskId: props.parentTask.Id,
      projectId: props.parentTask.ProjectId,
    },
  });
});
/**Добавить оповещение */
const addNotification = (message: string, isError: boolean = false, life?: number) => {
  TirPmNotificationEventBus.emit(
    'add',
    new TirPmNotificationModel({
      title: message,
      type: isError ? 'error' : 'success',
      group: 'general',
      life: life ?? 2000,
      closable: true,
    }),
  );
};
/**Скопировать название и ссылку */
const copyNameAndLinkTask = async () => {
  const routePath = router.resolve(getTaskRoute())?.href;
  if (!routePath) return;

  const origin =
    window.location.hostname === 'localhost' ? 'https://beta.hub-pm.com' : window.location.origin;

  const link = origin + routePath;
  const textContent = `${props.parentTask.Id} ${props.parentTask.Name}`;

  if (await copyToClipboard(`[${textContent}](${link})`)) {
    $contextMenu.value.close();
    addNotification('Название и ссылка тикета скопирована');
  }
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_unref(TirPmContextMenu), {
      class: "taks-parent-view__context-menu",
      ref_key: "$contextMenu",
      ref: $contextMenu,
      "min-width": "20rem",
      maxHeight: "max-content",
      "trigger-buttons": [_unref(TirPmContextMenuMouseButtonEnum).Right]
    }, {
      content: _withCtx(() => [
        (props.parentTask.HasAccessToParentTask)
          ? (_openBlock(), _createBlock(_unref(TirPmContextMenuButton), {
              key: 0,
              onClick: openDrawer
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_9, [
                  _createVNode(_unref(CurtainIcon), { class: "taks-parent-view__menu-icon" }),
                  _createTextVNode(" Открыть в шторке ")
                ])
              ]),
              _: 1
            }))
          : _createCommentVNode("", true),
        (props.parentTask.HasAccessToParentTask)
          ? (_openBlock(), _createBlock(_unref(RouterLink), {
              key: 1,
              to: computedRoute.value,
              target: "_blank"
            }, {
              default: _withCtx(() => [
                _createVNode(_unref(TirPmContextMenuButton), null, {
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_10, [
                      _createVNode(_unref(ArrowsPointingOutIcon), { class: "taks-parent-view__menu-icon" }),
                      _createTextVNode(" Открыть в новой вкладке ")
                    ])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["to"]))
          : _createCommentVNode("", true),
        _createVNode(_unref(RouterLink), { to: openSchema.value }, {
          default: _withCtx(() => [
            _createVNode(_unref(TirPmContextMenuButton), null, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_11, [
                  _createVNode(_unref(MapIcon), { class: "taks-parent-view__menu-icon" }),
                  _createTextVNode(" Посмотреть карту проекта ")
                ])
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["to"]),
        _createVNode(_unref(TirPmContextMenuButton), { onClick: copyNameAndLinkTask }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_12, [
              _createVNode(_unref(ShareIcon), { class: "taks-parent-view__menu-icon" }),
              _createTextVNode(" Скопировать название и ссылку ")
            ])
          ]),
          _: 1
        })
      ]),
      default: _withCtx(() => [
        _createVNode(_unref(TirPmRouterLink), {
          isDisabled: !__props.parentTask.HasAccessToParentTask,
          class: _normalizeClass([
        'taks-parent-view',
        { 'taks-parent-view--no-access': !__props.parentTask.HasAccessToParentTask },
        { 'in-drawer': __props.inDrawer },
      ]),
          to: computedRoute.value,
          onMousedown: _cache[3] || (_cache[3] = _withModifiers(() => {}, ["middle","prevent"]))
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_1, _toDisplayString(__props.parentTask.Id), 1),
            _createElementVNode("div", _hoisted_2, [
              _createVNode(_unref(ConnectIcon), { class: "taks-parent-view__parent-icon" }),
              _hoisted_3
            ]),
            _createElementVNode("div", _hoisted_4, _toDisplayString(__props.parentTask.Name), 1),
            (__props.showDeleteButton && __props.parentTask.HasAccessToParentTask)
              ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                  _createElementVNode("div", {
                    onClick: _cache[2] || (_cache[2] = _withModifiers(() => {}, ["stop","prevent"]))
                  }, [
                    _createVNode(_unref(TirPmPopover), {
                      ref_key: "$confirmUnattachPopover",
                      ref: $confirmUnattachPopover,
                      "custom-position": {
              right: '0rem',
              bottom: '0.25rem',
            }
                    }, {
                      content: _withCtx(() => [
                        _createElementVNode("div", _hoisted_6, [
                          _hoisted_7,
                          _createElementVNode("div", _hoisted_8, [
                            _createVNode(_unref(TirPmButton), {
                              variant: _unref(TirPmButtonVariantEnum).PrimaryState,
                              size: _unref(TirPmButtonSizeEnum).Small,
                              "is-loading": __props.isLoadingUnattach,
                              onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (emit('unattach')), ["stop"]))
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(" Открепить ")
                              ]),
                              _: 1
                            }, 8, ["variant", "size", "is-loading"]),
                            _createVNode(_unref(TirPmButton), {
                              variant: _unref(TirPmButtonVariantEnum).SecondaryState,
                              size: _unref(TirPmButtonSizeEnum).Small,
                              "is-disabled": __props.isLoadingUnattach,
                              onClick: _cache[1] || (_cache[1] = _withModifiers(($event: any) => ($confirmUnattachPopover.value?.close()), ["stop"]))
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(" Отмена ")
                              ]),
                              _: 1
                            }, 8, ["variant", "size", "is-disabled"])
                          ])
                        ])
                      ]),
                      default: _withCtx(() => [
                        _createVNode(_unref(TirPmTooltipElement), {
                          position: _unref(TirPmTooltipElementPlacementEnum).Left
                        }, {
                          content: _withCtx(() => [
                            _createTextVNode("Удалить связь ")
                          ]),
                          default: _withCtx(() => [
                            _createVNode(_unref(TirPmButton), {
                              variant: _unref(TirPmButtonVariantEnum).LinkState,
                              size: _unref(TirPmButtonSizeEnum).Small,
                              "is-loading": __props.isLoadingUnattach
                            }, {
                              leftSlot: _withCtx(() => [
                                _createVNode(_unref(TrashIcon))
                              ]),
                              _: 1
                            }, 8, ["variant", "size", "is-loading"])
                          ]),
                          _: 1
                        }, 8, ["position"])
                      ]),
                      _: 1
                    }, 512)
                  ])
                ]))
              : _createCommentVNode("", true)
          ]),
          _: 1
        }, 8, ["isDisabled", "class", "to"])
      ]),
      _: 1
    }, 8, ["trigger-buttons"]),
    _createVNode(_unref(TaskDrawer), {
      ref_key: "$taskDrawer",
      ref: $taskDrawer
    }, null, 512)
  ], 64))
}
}

})